/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
/* eslint-disable react/prop-types */
import React, { useContext, createContext, useState, useEffect } from 'react';
import {
  APP_CONFIG,
  APP_LOADER_URL,
  APP_LOGO_URL,
  APP_MAIN_URL,
  APP_WEB_URL,
} from './AppStorageStaticNames';
import {
  getValueFromAppConfig,
  setDataInLS,
  setStringInLs,
} from '../shared/helper-utils/localStorage';
import AppLoading from '../shared/components/app-loading/AppLoading';
import { getDefaultSeo } from '../shared/components/app-seo/seoRoutes';

export const AppContext = createContext(null);

export const useAppContext = () => useContext(AppContext);

const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};
const hexToRgba = (hex, opacity) => {
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const rgbToHex = (r, g, b) => {
  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
};

const lightenColor = (hex, percentage) => {
  const { r, g, b } = hexToRgb(hex);

  const newR = Math.round(r + (255 - r) * (percentage / 100));
  const newG = Math.round(g + (255 - g) * (percentage / 100));
  const newB = Math.round(b + (255 - b) * (percentage / 100));

  return rgbToHex(newR, newG, newB);
};

const generateShades = (color, isPrimary) => {
  if (isPrimary) {
    return {
      primaryColor: color,
      primaryColor80: lightenColor(color, 20),
      primaryColor60: lightenColor(color, 40),
      primaryColor40: lightenColor(color, 60),
      primaryColor20: lightenColor(color, 80),
      primaryColor10: lightenColor(color, 90),
      primaryColor5: lightenColor(color, 95),
      primaryColorOpacity90: hexToRgba(color, 0.9),
    };
  }
  return {
    secondaryColor: color,
    secondaryColor80: lightenColor(color, 20),
    secondaryColor60: lightenColor(color, 40),
    secondaryColor40: lightenColor(color, 60),
    secondaryColor20: lightenColor(color, 80),
    secondaryColor10: lightenColor(color, 90),
    secondaryColor5: lightenColor(color, 95),
  };
};

const isNullOrEmpty = (value) => {
  try {
    if (
      value === '' ||
      value === null ||
      value === 'null' ||
      value === undefined ||
      value === 'undefined' ||
      value === false ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const getAirlines = (airlines) => {
  try {
    if (!isNullOrEmpty(airlines)) {
      return airlines
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [];
  } catch (error) {
    return [];
  }
};

export default function AppConfigWrapper({ children }) {
  const [appConfig, setAppConfig] = useState({});
  const [shouldShow, setShouldsShow] = useState();

  const getConfigData = async () => {
    const configRes = await fetch(`${APP_WEB_URL}appv2.jsp`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    });

    if (configRes?.Root?.Status === 'OK') {
      const { ConfigSetting } = configRes.Root.Result.ConfigSettings;
      const configSettings = Array.isArray(ConfigSetting)
        ? ConfigSetting
        : [ConfigSetting];
      setDataInLS(APP_CONFIG, configSettings);
      const mainUrl = getValueFromAppConfig('SAAS_APP_MAIN_URL');
      const dbName = getValueFromAppConfig('SAASDBNAME');
      const newLogoUrl = `https://iweenclientuploads.s3.ap-south-1.amazonaws.com/${dbName}.png`;
      const oldLogoUrl = `${mainUrl}saasimages/${dbName}_logo.jpg`;
      const logoUrlPromise = new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(newLogoUrl);
        img.onerror = () => resolve(oldLogoUrl);
        img.src = newLogoUrl;
      });
      setStringInLs(APP_MAIN_URL, getValueFromAppConfig('SAAS_APP_MAIN_URL'));
      // setStringInLs(
      //   APP_LOGO_URL,
      //   `${getValueFromAppConfig(
      //     'SAAS_APP_MAIN_URL',
      //   )}saasimages/${getValueFromAppConfig('SAASDBNAME')}_logo.jpg`,
      // );
      setStringInLs(
        APP_LOADER_URL,
        `${getValueFromAppConfig(
          'SAAS_APP_MAIN_URL',
        )}saasimages/${getValueFromAppConfig('SAASDBNAME')}_loader.gif`,
      );

      // const faviconUrl = `${getValueFromAppConfig(
      //   'SAAS_APP_MAIN_URL',
      // )}saasimages/${getValueFromAppConfig('SAASDBNAME')}_logo.jpg`;
      const faviconUrl = `${
        process.env.PUBLIC_URL
      }/favicon.ico?v=${Date.now()}`;

      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }

      link.href = faviconUrl;

      const projectName =
        configSettings.find(
          (obj) => obj.ConfigKey.split(' ')[1] === 'SAAS_PROJECT_NAME',
        )?.ConfigValue || 'B2B Site';

      const { title: defaultTitle, description: descriptionContent } =
        getDefaultSeo(projectName);
      document.title = defaultTitle;
      let metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute('content', descriptionContent);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = descriptionContent;
        document.head.appendChild(metaDescription);
      }

      const clinetFonts =
        configSettings.find(
          (obj) => obj.ConfigKey.split(' ')[1] === 'SAAS_FONT_FAMILY',
        )?.ConfigValue || 'Poppins';

      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = `https://fonts.googleapis.com/css2?family=${clinetFonts}:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap`;
      document.head.appendChild(fontLink);
      document.documentElement.style.setProperty(
        '--appFont',
        `'${clinetFonts}', sans-serif`,
      );

      const hasObject = configSettings.find(
        (obj) => obj.ConfigKey.split(' ')[1] === 'SAAS_APP_MAIN_URL',
      );

      const clientPrimaryColor = getValueFromAppConfig('SAAS_PRIMARY_COLOR')
        ? `#${getValueFromAppConfig('SAAS_PRIMARY_COLOR')}`
        : '';
      const clientSecondaryColor = getValueFromAppConfig('SAAS_SECONDARY_COLOR')
        ? `#${getValueFromAppConfig('SAAS_SECONDARY_COLOR')}`
        : '';
      let hasFlight = false;
      let hasHotel = false;
      let hasBus = false;
      let hasTrain = false;
      let hasInsurance = false;
      let hasCruise = false;
      let hasCab = false;
      let hasPackage = false;
      let hasVisa = false;
      let hasGroupbooking = false;
      let hasMultiCity = false;
      let hasContactUsForm = false;
      let hasPortfolio = false;
      let hasEsim = false;
      let hasEsimfast = false;
      let hasTourPackages = false;
      let hasHoneymoonPackages = false;
      let hasZindagiDobara = false;
      let hasVisaForm = false;
      let hasEtcForm = false;
      let hasTopDeals = false;
      let hotelinvoicetax = true;
      let hasResheduleOfline = false;
      let hasBannerImageslanding = false;
      let hasOnlineVisa = false;
      let helpline24 = false;

      if (!isNullOrEmpty(getValueFromAppConfig('SAAS_APP_SERVICES'))) {
        hasFlight =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('flight') > -1;
        hasHotel =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('hotel') > -1;
        hasGroupbooking =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('groupbooking') > -1;
        hotelinvoicetax =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('hotelinvoicemodi') > -1;
        hasBus =
          getValueFromAppConfig('SAAS_APP_SERVICES').split(',').indexOf('bus') >
          -1;
        hasTrain =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('train') > -1;
        hasInsurance =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('insurance') > -1;
        hasCruise =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('cruise') > -1;
        hasCab =
          getValueFromAppConfig('SAAS_APP_SERVICES').split(',').indexOf('cab') >
          -1;
        hasPackage =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('package') > -1;
        hasVisa =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('visa') > -1;
        hasMultiCity =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('multicity') > -1;
        hasContactUsForm =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('contactusform') > -1;
        hasPortfolio =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('portfolio') > -1;
        hasEsim =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('esim') > -1;
        hasEsimfast =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('esimfast') > -1;
        hasTourPackages =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('tourpackage') > -1;
        hasHoneymoonPackages =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('honeymoonpackage') > -1;
        hasZindagiDobara =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('zindagidobara') > -1;
        hasVisaForm =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('visaform') > -1;
        hasOnlineVisa =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('onlinevisa') > -1;
        hasEtcForm =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('etctab') > -1;
        hasTopDeals =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('topdeals') > -1;
        hasResheduleOfline =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('oflinereshedule') > -1;
        helpline24 =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('helpline24') > -1;
        hasBannerImageslanding =
          getValueFromAppConfig('SAAS_APP_SERVICES')
            .split(',')
            .indexOf('bannerimageslanding') > -1;
      }
      const configObj = {
        ...generateShades(clientPrimaryColor, true),
        ...generateShades(clientSecondaryColor, false),
        clientPrimaryColor,
        clientSecondaryColor,
        hasFlight,
        hasHotel,
        hotelinvoicetax,
        hasBus,
        hasTrain,
        hasInsurance,
        hasCruise,
        hasCab,
        hasPackage,
        hasVisa,
        hasGroupbooking,
        hasResheduleOfline,
        hasBannerImageslanding,
        helpline24,
        hasMultiCity,
        hasContactUsForm,
        hasPortfolio,
        hasEsim,
        hasEsimfast,
        hasHoneymoonPackages,
        hasTourPackages,
        hasZindagiDobara,
        hasVisaForm,
        hasEtcForm,
        hasTopDeals,
        hasOnlineVisa,
        appMainUrl: getValueFromAppConfig('SAAS_APP_MAIN_URL'),
        companyName: getValueFromAppConfig('SAAS_PROJECT_NAME'),
        showNameinLoginHeader:
          getValueFromAppConfig('SHOWNAMEINLOGINHEADER') === 'show',
        showRecentSearches:
          getValueFromAppConfig('ShowRecentSearches') === 'true' || false,
        appCurrency: getValueFromAppConfig('SAAS_APP_CURRENCY'),
        appCountryCode: !isNullOrEmpty(
          getValueFromAppConfig('SAAS_APP_COUNTRY_CODE'),
        )
          ? getValueFromAppConfig('SAAS_APP_COUNTRY_CODE')
          : 'IN',
        appMobileCode: !isNullOrEmpty(
          getValueFromAppConfig('SAAS_APP_MOBILE_CODE'),
        )
          ? getValueFromAppConfig('SAAS_APP_MOBILE_CODE')
          : '+91',
        appFlightCarrierImg: isNullOrEmpty(
          getValueFromAppConfig('SAAS_APP_FLIGHT_CARRIER_IMG'),
        )
          ? 'https://static.iween.co.in/airlinelogos/'
          : getValueFromAppConfig('SAAS_APP_FLIGHT_CARRIER_IMG'),
        hotelPaxCountry: getValueFromAppConfig('SAAS_HOTEL_PAX_COUNTRY'),
        isWinYatraBalance: getValueFromAppConfig('SAAS_IS_WIN_YATRA_BALANCE'),
        logoHeight: isNullOrEmpty(getValueFromAppConfig('SAAS_APP_LOGO_HEIGHT'))
          ? '40'
          : getValueFromAppConfig('SAAS_APP_LOGO_HEIGHT'),
        logoWidth: getValueFromAppConfig('SAAS_APP_LOGO_WIDTH'),
        isAppEncrypted: getValueFromAppConfig('SAAS_IS_APP_ENCRYPTED'),
        pageAfterLogin: getValueFromAppConfig('SAAS_PAGE_AFTER_LOGIN'),
        appDbName: getValueFromAppConfig('SAASDBNAME'),
        appLogoServerUrl: '',
        companyAddress: getValueFromAppConfig('COMPANYADD'),
        supportMail: getValueFromAppConfig('SUPPORTEMAILID'),
        supportNumber: getValueFromAppConfig('customercarenumbers'),
        termsAndConditionsLink: getValueFromAppConfig(
          'APP_TERMS_CONDITIONS_LINK',
        ),
        copyrightDisclaimer: getValueFromAppConfig('SAAS_APP_COPYRIGHT_FOOTER'),
        domesticOnewayNormalAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ONEWAY_NORMAL_AIRLINES'),
        ),
        domesticMultiCityCorporateOnlyAirlines: getAirlines(
          getValueFromAppConfig(
            'SAAS_DOMESTIC_MULTICITY_CORPORATE_ONLY_AIRLINES',
          ),
        ),
        domesticOnewayCorporateOnlyAllAirlines: getAirlines(
          getValueFromAppConfig(
            'SAAS_DOMESTIC_ONEWAY_CORPORATE_ONLY_ALL_AIRLINES',
          ),
        ),
        domesticOnewayCorporateOnlyAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ONEWAY_CORPORATE_ONLY_AIRLINES'),
        ),
        domesticOnewayBrandedAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ONEWAY_BRANDED_AIRLINES'),
        ),
        domesticOnewaySeriesAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ONEWAY_SERIES_AIRLINES'),
        ),
        domesticRoundtripNormalAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ROUNDTRIP_NORMAL_AIRLINES'),
        ),
        domesticRoundtripCorporateAirlines: getAirlines(
          getValueFromAppConfig(
            'SAAS_DOMSETIC_ROUNDTRIP_CORPORATE_ONLY_AIRLINES',
          ),
        ),
        domesticRoundtripCorporateAllAirlines: getAirlines(
          getValueFromAppConfig(
            'SAAS_DOMSETIC_ROUNDTRIP_CORPORATE_ONLY_ALL_AIRLINES',
          ),
        ),
        domesticRoundtripLccSpecialRoundtripAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ROUNDTRIP_LCC_SPECIAL_AIRLINES'),
        ),
        domesticRoundtripGdsSpecialRoundtripAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_ROUNDTRIP_GDS_SPECIAL_AIRLINES'),
        ),
        domesticMultiCityNormalAirlines: getAirlines(
          getValueFromAppConfig('SAAS_DOMESTIC_MULTICITY_NORMAL_AIRLINES'),
        ),
        internationalOnewayNormalAirlines: getAirlines(
          getValueFromAppConfig('SAAS_INTERNATIONAL_ONEWAY_NORMAL_AIRLINES'),
        ),
        internationalOnewayCorporateOnlyAirlines: getAirlines(
          getValueFromAppConfig(
            'SAAS_INTERNATIONAL_ONEWAY_CORPORATE_ONLY_AIRLINES',
          ),
        ),
        internationalRoundtripNormalAirlines: getAirlines(
          getValueFromAppConfig('SAAS_INTERNATIONAL_ROUNDTRIP_NORMAL_AIRLINES'),
        ),
        isIntlClient: getValueFromAppConfig('isIntlClient') || false,
        showDefaultSectors:
          getValueFromAppConfig('showDefaultSectors') || 'true',
        showSectorSuggestions:
          getValueFromAppConfig('showSectorSuggestions') || 'false',
        isMoreFaresRequiredForEachFareType:
          getValueFromAppConfig('isMoreFaresRequiredForEachFareType') ===
            'true' ||
          getValueFromAppConfig('isMoreFaresRequiredForEachFareType') ||
          false,
        ShowTboPriceBlack:
          getValueFromAppConfig('SHOW_TBO_PRICE_BLACK') || false,
        showDiscountedPrice:
          getValueFromAppConfig('showDiscountedPrice') === 'true' || false,
        isPanVerificationrequired:
          getValueFromAppConfig('isPanVerificationrequired') === 'true' ||
          getValueFromAppConfig('isPanVerificationrequired') ||
          false,
        isGstVerificationrequired:
          getValueFromAppConfig('isGstVerificationrequired') === 'true' ||
          getValueFromAppConfig('isGstVerificationrequired') === true ||
          false,
        isAadharVerificationrequired:
          getValueFromAppConfig('isAadharVerificationrequired') === 'true' ||
          getValueFromAppConfig('isAadharVerificationrequired') ||
          false,
        hideHeaderWatermark:
          getValueFromAppConfig('hideHeaderWatermark') === 'true' ||
          getValueFromAppConfig('hideHeaderWatermark') ||
          false,
        hideFooterinsearch:
          getValueFromAppConfig('hideFooterinsearch') === 'true' ||
          getValueFromAppConfig('hideFooterinsearch') ||
          false,
      };
      const resolvedLogoUrl = await logoUrlPromise;
      setStringInLs(APP_LOGO_URL, resolvedLogoUrl);
      setAppConfig({ ...configObj });

      if (hasObject) {
        setShouldsShow(true);
      }
    }
  };
  useEffect(() => {
    getConfigData();
  }, []);

  return (
    <AppContext.Provider value={{ appConfig }}>
      {shouldShow ? children : <AppLoading isLoading />}
    </AppContext.Provider>
  );
}
